import React from "react";
import "./HoldupLabel.scss";
import { AspectRatio } from "../api/ReplayVariables";
import sizeMe from "react-sizeme";
import NumberFormat from "react-number-format";

function HoldupLabel({
  size,
  zoneSize,
  realTableRatio,
  holdUp,
  smallBlind,
  bigBlind,
  ante,
  bbMode,
  level,
  levelLabel
}) {
  const cardHeight =
    AspectRatio.refBoardCardWidth *
    realTableRatio *
    AspectRatio.refBoardCardHeightRatio;
  const boardPotMargin = AspectRatio.refBoardPotMargin * realTableRatio;

  const convertToFixed = (inputnum) => {
    var mynum = inputnum.toFixed(2);
    var mynumstr = mynum.toString();
    return parseFloat(mynumstr);
  };

  const nbBB = convertToFixed(holdUp / bigBlind, 1);

  return (
    <table
      className="holdup"
      style={{
        top:
          zoneSize.height / 2 +
          (holdUp>0 ? 0 : cardHeight / 2) +
          size.height -
          (holdUp>0 ? 0:boardPotMargin) +
          "px",
        marginLeft: "-" + size.width / 2 + "px"
      }}
    >
      <tbody>
        {holdUp > 0 ? (
          <tr
            style={{
              lineHeight: AspectRatio.refLineHeight * realTableRatio * 1.4 + "px",
              fontSize: AspectRatio.refFontSize * realTableRatio * 1.4 + "px"
            }}
          >
            <td width="50%" align="right">
              &nbsp;ESCAPE
            </td>
            <td width="50%" align="left">
              &nbsp;
              <NumberFormat
                value={bbMode ? convertToFixed(nbBB) : holdUp.toFixed(2)}
                displayType={"text"}
                thousandSeparator={true}
                renderText={(value) => <>{value}</>}
              />
            </td>
          </tr>) : <></>}
          <tr
            style={{
              lineHeight: AspectRatio.refLineHeight * realTableRatio * 0.8 + "px",
              fontSize: AspectRatio.refFontSize * realTableRatio * 0.8 + "px"
            }}
          >
          <td colSpan="2" align="center">
              {/* v2-1488: the tournament level before its blinds, when Xeester knows it */}
              {level > 0 ? (
                <>
                  {levelLabel}&nbsp;{level}&nbsp;-&nbsp;
                </>
              ) : <></>}
              <NumberFormat
                value={convertToFixed(smallBlind)}
                displayType={"text"}
                thousandSeparator={true}
                renderText={(value) => <>{value}</>}
              />&nbsp;/&nbsp; 
              <NumberFormat
                value={convertToFixed(bigBlind)}
                displayType={"text"}
                thousandSeparator={true}
                renderText={(value) => <>{value}</>}
            />
            {ante > 0 ? (
              <>
              &nbsp;+&nbsp;<NumberFormat
                value={convertToFixed(ante)}
                displayType={"text"}
                thousandSeparator={true}
                renderText={(value) => <>{value}</>}
            />

              </>
            ): <></>}
            </td>
          </tr>        
      </tbody>
    </table>
  );
}
export default sizeMe({
  monitorHeight: true,
  monitorWidth: true
})(HoldupLabel);
